module.exports = __webpack_public_path__ + "static/media/kazoo.b04680db.svg";